import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AnalysisPreview from "@/pages/AnalysisPreview";
import About from "@/pages/About";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Chat from "@/pages/Chat";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Result from "@/pages/Result";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/result/:conversationId" element={<Result />} />
          <Route path="/analyse/preview" element={<AnalysisPreview />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
